<template>
  <div class="license-expired-container">
    <!-- 背景装饰 -->
    <div class="bg-pattern"></div>

    <!-- 主要内容 -->
    <el-card class="license-card" :class="licenseStatusClass">
      <div class="status-indicator" :class="`status-${licenseStatus}`">
        <i :class="statusIcon"></i>
      </div>

      <h1 class="title">{{ pageTitle }}</h1>

      <!-- 许可证信息 -->
      <div class="license-info">
        <el-descriptions :column="isMobile ? 1 : 2" border>
          <el-descriptions-item label="产品名称">{{ licenseInfo.productName }}</el-descriptions-item>
          <el-descriptions-item label="授权用户">{{ licenseInfo.companyName }}</el-descriptions-item>
          <el-descriptions-item label="CPU序列号">{{ serverInfo.cpuSerial || '-'}}</el-descriptions-item>
          <el-descriptions-item label="主板序列号">{{ serverInfo.mainBoardSerial || '-' }}</el-descriptions-item>
          <el-descriptions-item label="MAC地址">
            <template v-if="serverInfo.macAddress && serverInfo.macAddress.length>0">
              <el-tag v-for="item in serverInfo.macAddress">{{ item }}</el-tag>
            </template>
            <div v-else>-</div>
          </el-descriptions-item>
          <el-descriptions-item label="当前状态">
            <el-tag :type="statusTagType" size="small">{{ licenseInfo.status }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="IP地址" :span="2">
            <div v-if="serverInfo.ipAddress && serverInfo.ipAddress.length>0">
              <el-tag v-for="(item,index) in serverInfo.ipAddress" :style="index !=0?'margin-top: 5px;margin-left:5px;':''" :key="index">{{ item }}</el-tag>
            </div>
            <div v-else>-</div>
          </el-descriptions-item>

        </el-descriptions>
      </div>

      <!-- 状态描述 -->
      <div class="status-description">
        <el-alert
            :title="statusDescription.title"
            :type="statusDescription.type"
            :description="statusDescription.message"
            :closable="false"
            show-icon
        />
      </div>

      <!-- 功能按钮 -->
      <div class="action-buttons">
<!--
        <el-button
            type="primary"
            @click="renewLicense"
            :loading="renewLoading"
            :disabled="licenseStatus === 'expired'"
        >
          <i class="el-icon-refresh"></i> 立即续期
        </el-button>
-->

        <el-button
            @click="showContactDialog"
        >
          <i class="el-icon-service"></i> 联系客服
        </el-button>

        <el-button
            type="warning" plain
            @click="checkUpdate"
        >
          <i class="el-icon-back"></i> 返回登陆
        </el-button>
      </div>
    </el-card>

    <!-- 联系客服对话框 -->
    <el-dialog
        title="联系客服"
        :visible.sync="contactDialogVisible"
        width="500px"
        custom-class="contact-dialog"
    >
      <div class="contact-info">
        <div class="contact-item">
          <i class="el-icon-phone"></i>
          <div>
            <h4>客服热线</h4>
            <p>0755-27795086 / 020-32229138</p>
            <p class="sub-text">工作日 9:00-18:00</p>
          </div>
        </div>
        <div class="contact-item">
          <i class="el-icon-s-shop"></i>
          <div>
            <h4>官网</h4>
            <p>https://www.sycreader.com/</p>
          </div>
        </div>
<!--        <div class="contact-item">
          <i class="el-icon-chat-dot-round"></i>
          <div>
            <h4>在线客服</h4>
            <el-button type="text" @click="openOnlineService">点击打开在线聊天</el-button>
          </div>
        </div>-->
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="contactDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import http from "@/utils/http";

export default {
  name: 'LicenseExpiredPage',

  data() {
    return {
      // 许可证状态：normal（正常）、warning（即将到期）、expired（已过期）
      licenseStatus: 'expired',
      // 倒计时
      countdown: {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
      },
      // 许可证信息
      licenseInfo: {
        productName: '云汉扫企业管理平台',
        companyName: '-',
        status: '已过期'
      },
      // 状态描述
      statusDescription: {
        title: '许可证已到期',
        message: '您的许可证已到期，请联系管理员续期以保证系统正常使用。',
        type: 'warning'
      },
      // 控制变量
      renewLoading: false,
      contactDialogVisible: false,
      isMobile: false,
      serverInfo:{}
    };
  },

  computed: {
    // 页面标题
    pageTitle() {
      const titles = {
        normal: '许可证管理',
        warning: '许可证即将到期',
        expired: '许可证已过期'
      };
      return titles[this.licenseStatus] || '许可证状态';
    },

    // 状态图标
    statusIcon() {
      const icons = {
        normal: 'el-icon-success',
        warning: 'el-icon-warning',
        expired: 'el-icon-error'
      };
      return icons[this.licenseStatus] || 'el-icon-question';
    },

    // 状态标签类型
    statusTagType() {
      const types = {
        normal: 'success',
        warning: 'warning',
        expired: 'danger'
      };
      return types[this.licenseStatus] || 'info';
    },
    // 卡片样式类
    licenseStatusClass() {
      return `license-${this.licenseStatus}`;
    },

  },

  created() {
    this.getServerInfo();
    this.checkMobile();
    this.getCompanyInfo();
  },

  beforeDestroy() {
  },
  methods: {
    getServerInfo(){
        http.get("/server/license/getServerInfos").then(response => {
          const {code,data} = response;
          if(code == 200){
            this.serverInfo = data;
          }
        })
    },
    getCompanyInfo(){
        http.get("/server/umsCompany/queryCurrentCompany").then(response => {
          const {code,data} = response;
          if(code == 200){
            this.licenseInfo.companyName = data?.name;
          }
        })
    },
    // 显示联系客服对话框
    showContactDialog() {
      this.contactDialogVisible = true;
    },
    // 打开在线客服
    openOnlineService() {
      this.$message.info('正在打开在线客服系统...');
      // 这里可以集成实际的在线客服系统
    },

    // 检查更新
    checkUpdate() {
      this.$router.replace("/login");
    },
    // 检查是否为移动端
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    }
  }
};
</script>

<style scoped>
.license-expired-container {
  /*min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
  position: relative;
  overflow: hidden;*/

  width: 100%;
  height: 100vh;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: url("@/assets/login/background.png");
  background-size: 100% 100%;
}

.bg-pattern {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background:
      radial-gradient(circle at 20% 80%, rgba(255,255,255,0.1) 0%, transparent 50%),
      radial-gradient(circle at 80% 20%, rgba(255,255,255,0.1) 0%, transparent 50%);
}

.license-card {
  width: 100%;
  max-width: 1000px;
  padding: 40px;
  position: relative;
  z-index: 1;
  border-radius: 15px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
}

.license-warning {
  border-top: 4px solid #e6a23c;
}

.license-expired {
  border-top: 4px solid #f8dede;
}

.license-normal {
  border-top: 4px solid #67c23a;
}

.status-indicator {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 30px;
  font-size: 40px;
}

.status-normal {
  background: #f0f9eb;
  color: #67c23a;
}

.status-warning {
  background: #fdf6ec;
  color: #e6a23c;
}

.status-expired {
  background: #fef0f0;
  color: #f56c6c;
}

.title {
  text-align: center;
  font-size: 28px;
  font-weight: 600;
  margin-bottom: 30px;
  color: #303133;
}

.countdown-section {
  text-align: center;
  margin-bottom: 30px;
}

.countdown-label {
  font-size: 16px;
  color: #606266;
  margin-bottom: 15px;
}

.countdown-timer {
  display: flex;
  justify-content: center;
  gap: 20px;
}

.time-unit {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 60px;
}

.time-value {
  font-size: 32px;
  font-weight: bold;
  color: #409eff;
  padding: 10px;
  background: #f5f7fa;
  border-radius: 8px;
  width: 100%;
  text-align: center;
}

.time-label {
  margin-top: 8px;
  font-size: 14px;
  color: #909399;
}

.license-info {
  margin: 30px 0;
}

.expire-date {
  font-weight: bold;
}

.expire-date.warning {
  color: #e6a23c;
}

.expire-date.expired {
  color: #f56c6c;
}

.expire-date.normal {
  color: #67c23a;
}

.status-description {
  margin: 30px 0;
}

.action-buttons {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin: 40px 0;
}

.renewal-history {
  margin-top: 40px;
  padding-top: 30px;
  border-top: 1px solid #ebeef5;
}

.renewal-history h3 {
  font-size: 18px;
  color: #303133;
  margin-bottom: 20px;
}

.contact-info {
  padding: 20px 20px;
}

.contact-item {
  display: flex;
  align-items: center;
  padding: 15px 0;
  border-bottom: 1px solid #ebeef5;
}

.contact-item:last-child {
  border-bottom: none;
}

.contact-item i {
  font-size: 24px;
  color: #409eff;
  margin-right: 20px;
  min-width: 40px;
}

.contact-item h4 {
  margin: 0 0 5px 0;
  color: #303133;
}

.contact-item p {
  margin: 0;
  color: #606266;
}

.sub-text {
  font-size: 12px;
  color: #909399 !important;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .license-card {
    padding: 20px;
  }

  .countdown-timer {
    gap: 10px;
  }

  .time-unit {
    min-width: 50px;
  }

  .time-value {
    font-size: 24px;
    padding: 8px;
  }

  .action-buttons {
    flex-direction: column;
    gap: 10px;
  }

  .action-buttons .el-button {
    width: 100%;
  }
}
</style>

<style>
.contact-dialog .el-dialog__body {
  padding: 0 20px;
}
.contact-dialog .el-dialog__header {
  padding: 1.25rem 1.25rem 0.625rem;
}
</style>